import { SupportTicket } from "@/types/supportTicket.ts";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card.tsx";
import { Separator } from "@/components/ui/separator.tsx";
import { useTranslation } from "@/i18n";

const SupportTicketCard = ({ ticket }: { ticket: SupportTicket }) => {
  const { t } = useTranslation();
  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle>{`${ticket.category}: ${ticket.subject}`}</CardTitle>
        <CardDescription>{ticket.description}</CardDescription>
        <div className="w-full text-xs">
          {t("common.createdAt")}
          <span>
            {" "}
            {new Date(ticket.created_at).toLocaleString("en-US", {})}
          </span>
        </div>
      </CardHeader>
      <Separator />
      <CardContent>
        {!ticket.supportticketresponses.length && (
          <div className="w-full text-center text-xs">
            {t("support.noResponse")}
          </div>
        )}
        {ticket.supportticketresponses.map((response, index) => (
          <div
            key={index}
            dangerouslySetInnerHTML={{ __html: response.message }}
          />
        ))}
      </CardContent>
      <CardFooter>
        {!!ticket.responded_at && (
          <div className="w-full text-end text-xs">
            {t("support.respondedAt")}
            <span>
              {" "}
              {new Date(ticket.responded_at).toLocaleString("en-US", {})}
            </span>
          </div>
        )}
      </CardFooter>
    </Card>
  );
};

export default SupportTicketCard;
